module.exports = __webpack_public_path__ + "img/hr-solar-panel.e7d03c73.png";